import styled from "styled-components";

export const InvestmentCardContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(
    to right,
    #ffffff00 0%,
    #f8f8ff 50%,
    #ffffff00 100%
  );
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #696974;
  gap: 12px;

  p {
    font-size: 12px;
    text-align: center;
    color: #09d37c;
    border: 1px solid #09d37c;
    border-radius: 16px;
    padding: 2px 0;
    margin: 0;
    min-width: 80px;

    @media (max-width: 767px) {
      position: absolute;
      right: 56px;
      margin-top: 8px;
    }
  }

  button {
    max-width: 104px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    background: #f8f8ff;
  }
`;

export const OpportunityCode = styled.div`
  h1 {
    font-size: 16px;
    font-weight: bold;
    color: #171725;
    margin: 0;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ColumnsGrid = styled.div`
  width: 64%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(88px, 1fr));
  gap: 12px;

  @media (max-width: 767px) {
    width: 100%;
    gap: 16px;
    margin: 8px 0 12px;
  }
`;

export const ColumnsItem = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
  align-items: center;
  text-align: center;
  line-height: 14px;
  gap: 4px;

  span {
    color: #1f4ca0;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const InfoData = styled.span`
  display: flex;
  align-items: center;
  text-align: center;
  gap: 2px;
`;
